import { Component, OnInit } from '@angular/core';
import { SessionService } from '../core/session/session.service';
import { PageGuideService } from './page-guide.service';

@Component({
  selector: 'app-page-guide',
  templateUrl: './page-guide.component.html',
  styleUrls: ['./page-guide.component.css']
})
export class PageGuideComponent implements OnInit {

  constructor(private sessionService: SessionService, private pageGuideService: PageGuideService) { }

  ngOnInit() {
    
    this.pageGuideService.shutdownPageGuide();

    if (this.sessionService.isUserLogged()) {
      this.pageGuideService.startPageGuide();
    }
  }
}
